import * as Sentry from "@sentry/react";
import React, { ReactNode } from "react";

import { AdminContainer, AdminTitle } from "../../components/Admin";
import PageTitle from "../../components/PageTitle";
import Spacer from "../../components/Spacer";

import usePageWidthBreakpoint from "../../hooks/usePageWidthBreakpoint";

import css from "./AdminTablePageTemplate.module.scss";

type AdminTablePageTemplateProps = {
	pageName: string;
	description?: string;
	searchBar: ReactNode;
	mainContent: ReactNode;
	actionButtons?: ReactNode[];
};

const AdminTablePageTemplate = ({
	pageName,
	description,
	searchBar,
	mainContent,
	actionButtons = [],
}: AdminTablePageTemplateProps) => {
	const { isMobile } = usePageWidthBreakpoint();
	return (
		<Sentry.ErrorBoundary fallback={undefined}>
			<AdminContainer className={css.contentContainer}>
				<PageTitle title={pageName} />
				<AdminTitle includeSpacer={false} description={description}>
					{pageName}
				</AdminTitle>
				<Spacer height={4} />

				<div className={`${css.utils} ${isMobile ? css.mobileUtils : ""}`}>
					<div>{searchBar}</div>
					<div>{actionButtons?.map((button) => button)}</div>
				</div>
				<Spacer height={2} />
				<div>{mainContent}</div>
			</AdminContainer>
		</Sentry.ErrorBoundary>
	);
};

export default AdminTablePageTemplate;
